import AEM from 'base/js/aem';
import { richTextYtLinks } from 'base/js/templates/general/youtubeModal.js';

class Teaser extends AEM.Component {
    init() {
        // Add Aria-label to YouTube Image Modal Link
        const teaserImage = this.element.querySelector('.horzimage');
        const imageLink = this.element.querySelector('.cmp-image__link');
        this.hasVideo = this.element.querySelector('.yt-play-button');
        this.actions = this.element.querySelectorAll('.card-link');
        this.titleLink = this.element.querySelector('.card-heading-link');
        this.cardText = this.element.querySelector('.card-text');
        if (this.imageLink && (this.imageLink.dataset.modalType === 'youtube' || this.imageLink.dataset.modalType === 'native')) {
            const modalText = this.teaserImage.dataset.videoModalText ?? '';
            const sanitizedModalText = modalText.replace(/\u200B/g, '');
            const openModalText = this.teaserImage.dataset.openModalText;
            this.imageLink.ariaLabel = `${sanitizedModalText} ${openModalText}`;
        }
        this.links = this.element.querySelectorAll('.card-text a');
        richTextYtLinks(this.links);
        if (this.links.length === 0) {
            this.initializeClick();
        }

        this.initializeAccessibility();
    }

    initializeAccessibility() {
        if (this.actions) {
            const links = new Set();
            this.actions.forEach(action => links.add(action.href));
            if (this.titleLink && links.has(this.titleLink.href)) {
                this.titleLink.tabIndex = -1;
            } else if (this.titleLink) {
                links.add(this.titleLink.href);
            }
            if (this.imageTitleLink && links.has(this.imageTitleLink.href)) {
                this.imageTitleLink.tabIndex = -1;
            }
        }
    }

    initializeClick() {
        const actions = this.element.querySelectorAll('.card-link');
        const titleLink = this.element.querySelector('.card-heading-link');

        function openAction(e) {
            let link;
            if (e.currentTarget.querySelector('.card-link')) {
                link = e.currentTarget.querySelector('.card-link');
            } else if (e.currentTarget.querySelector('.card-heading-link')) {
                link = e.currentTarget.querySelector('.card-heading-link');
            }

            if (link && link.href) {
                if (link.target === '_blank' || e.ctrlKey || e.metaKey) {
                    window.open(link.href);
                    e.preventDefault();
                } else {
                    window.location.href = link.href;
                    e.preventDefault();
                }
            }
        }

        if (actions.length === 1 && !this.hasVideo) {
            this.element.role = 'button';
            this.element.addEventListener('click', openAction, true);
        } else if (titleLink && actions.length === 0 && !this.hasVideo) {
            this.element.role = 'button';
            this.element.addEventListener('click', openAction, true);
        }
    }
}

export { Teaser };
